module.exports = __webpack_public_path__ + "media/CN_002.c87c2ed8.mp3";